<template>
  <div>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Chi tiết</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Số lượt tối đa/user</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ max: 10, min_value: 0, alpha_num: true }"
              name="Số lượt tối đa/user"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập số lượng"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.numberOfAvailableUser"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Điều kiện áp dụng</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Giá trị đơn hàng tối thiểu*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true, max: 10, min_value: 0, alpha_num: true }"
              name="Giá trị đơn hàng tối thiểu"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập giá trị đơn hàng tối thiểu"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.minimumAmount"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Sản phẩm tặng</h3> 
          </v-col>
          <v-col cols="12" class="px-8 py-0 pt-2">
            <v-simple-table class="table-layout table-custom table-sku">
              <thead>
                <tr>
                  <th style="width:200px">SKU</th>
                  <th >Sản phẩm tặng</th> 
                  <th class="col-quantity text-center">Số lượng tặng</th> 
                  <th class="text-center">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <v-text-field
                      class="text-field text-field-no-message"
                      :clearable="true"
                      placeholder="Nhập SKU"
                      outlined
                      dense
                      maxLength="50"
                      v-model="newProductCode"
                      @keyup="checkSku"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-autocomplete
                      class="text-field text-field-no-message"
                      :clearable="true"
                      :items="allSkus"
                      item-value="code"
                      item-text="name"
                      :aLight="'right'"
                      placeholder="Nhập tên SKU"
                      attach
                      outlined
                      dense
                      v-model="newProductCode"
                      :disabled="isDisableActive"
                      :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                    ></v-autocomplete>
                  </td>
                  <td class="text-center">
                    <v-text-field
                      class="text-field text-field-no-message text-field-number"
                      :clearable="true"
                      placeholder="Nhập số lượng"
                      outlined
                      dense
                      type="number"
                      v-model="quantity"
                      :disabled="isDisableActive"
                    ></v-text-field>
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom class="mr-2">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addProduct" :disabled="isDisableActive">
                          mdi-plus-box
                        </v-icon>
                      </template>
                      <span>Thêm</span> 
                    </v-tooltip>
                  </td>
                </tr>
                <tr v-for="(item, index) in promotionCampaignConditionGiftByProduct" :key="index">
                  <td>
                    {{ item.productCode }}
                  </td>
                  <td>
                    {{ allSkuObj[item.productCode] }}
                  </td>
                  <td class="text-center">
                    {{ item.quantity }}
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeSku(item, index)" :disabled="isDisableActive">
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Xóa</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr style="height: 200px;"></tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </div> 
    </v-col>
  </div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    promotionCampaignConditionGiftByProduct: {
      type: Array,
      default: () => [],
    },
    isDisablePending: {
      type: Boolean,
      default: () => false,
    },
    isDisableActive: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
  },
  data() {
    return {
      newProductCode: null,
      quantity: null,
      allSkus: [],
      allSkuObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.getAllSkus();
  },
  beforeDestroy() {
  },
  methods: {
    async getAllSkus() {
      const params = {
        sku_name: '',
        status: 'active',
        sku_types: ['duo', 'tutor', 'combo'],
      }
      const res = await ProductRepository.basicSearchForCombo(params);
      this.allSkus = res.data;
      this.allSkus.forEach((item) => this.allSkuObj[item.code] = item.name);
    },
    onChangeApplyForm() {},
    addProduct() {
      const sku = this.allSkus.find((item) => item.code === this.newProductCode);

      if ((!sku)) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa chọn SKU',
        });
      }

      if (!this.newProductCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'SKU không tồn tại hoặc đã ngừng hoạt động',
        });
      }
      if (!this.quantity) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa nhập số lượng tặng',
        });
      }
      if (this.quantity && parseInt(this.quantity) > 9999999999) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Số lượng tặng phải nhỏ hơn 9999999999',
        });
      }

      if (this.quantity && parseInt(this.quantity) < 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Số lượng tặng phải lớn hơn 0',
        });
      }
      this.promotionCampaignConditionGiftByProduct.push({
        productCode: this.newProductCode,
        quantity: this.quantity,
        productName: sku.name,
        skuType: sku.itemType,
      });
      this.newProductCode = null;
      this.quantity = null;
    },
    removeSku(item, index) {
      this.promotionCampaignConditionGiftByProduct.splice(index, 1);
    },
    checkSku: _.debounce(function () {
      const sku = this.allSkus.find((item) => item.code === this.newProductCode);
      if (!sku && this.newProductCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Không tìm thấy SKU',
        });
      }
    }, 500),
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 300px;
}

.table-custom {
  th {
    background: #E7E8FF;
    border-left: 1px solid #fff;
  }
}
.col-code {
  width: 20% !important;
}
.col-name {
  width: 30% !important;
}
.col-quantity {
  width: 20% !important;
}
.col-action {
  width: 30% !important;
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
